<template>
  <div
    class="v-tokenInput"
    :class="{'v-tokenInput--invalid': isInvalid}"
  >

    <input
      type="number"
      class="v-tokenInput__field"
      :ref="inputId"
      :disabled="isTokenDisabled"
      :id="inputId"
      :maxLength="inputMaxLength"
      :tabindex="inputTabindex"
      v-model="inputValue"
      @keydown="handleKeypress"
      @input="handleInput($event.target.value)"
      @focus="$emit('focus')"
      @click="$emit('click', $event)"
    >
  </div>
</template>

<script>
export default {
  name: 'VTokenInput',

  props: {
    index: {
      type: Number,
    },
    inputId: {
      type: String,
      default: 'token_input',
    },
    inputMaxLength: {
      type: Number,
      default: 1,
    },
    inputTabindex: {
      type: Number,
      default: 1,
    },
    retrievedInputValue: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      inputValue: '',
    };
  },

  computed: {
    isTokenDisabled() {
      return !!this.isDisabled;
    },
    isTokenInvalid() {
      return !!this.isInvalid;
    },
    externalInputedValue() {
      return this.retrievedInputValue;
    },
  },

  watch: {
    externalInputedValue(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.inputValue = newValue;

        this.$emit('input', this.inputValue);
      }
    },

    isTokenDisabled(newValue, oldValue) {
      const inputKeepedValue = this.$refs[this.inputId].value;

      setTimeout(() => {
        this.inputValue = inputKeepedValue;
      }, 200);
    },

    isTokenInvalid(newValue, oldValue) {
      const inputKeepedValue = this.$refs[this.inputId].value;

      setTimeout(() => {
        this.inputValue = inputKeepedValue;
      }, 200);
    },
  },

  methods: {
    handleKeypress(event) {
      if (event.key === 'Backspace') {
        if (!this.inputValue) {
          this.$emit('focusPreviousField');
        }
      }

      return this.$emit('keypress', event);
    },

    setAutofocus() {
      if (this.index === 0) {
        this.$refs[this.inputId].focus();
      }
    },

    handleInput(eventValue) {
      if (this.index === 0 && eventValue.length === 6) {
        this.inputValue = eventValue[0];
      }
      this.$emit('input', eventValue);
    },
  },

  mounted() {
    this.setAutofocus();
  }
};
</script>

<style lang="scss" scoped>
.v-tokenInput {
  height: 54px;
  width: 42px;

  &--invalid {
    & .v-tokenInput__field {
      border-bottom-color: var(--color-error);
      border-bottom-width: 4px;
      color: var(--color-error);
    }
  }

  &__field {
    background-color: var(--color-grey-1);
    border: {
      bottom: {
        color: var(--color-grey-7);
        style: solid;
        width: 2px;
      }
      top: none;
      left: none;
      right: none;
    }
    border-radius: 4px 4px 0 0;
    font-size: 16px;
    height: 100%;
    text-align: center;
    transition: border-bottom-width 0.15s ease-in-out;
    width: 100%;

    &:focus {
      border-bottom-width: 4px;
    }

    &:disabled {
      background-color: var(--color-grey-2);
      border-bottom: 2px solid var(--color-grey-4);
      color: var(--color-grey-4);
    }
  }
}
</style>
